import { IBookingModel } from '../../interfaces/models/bookings.interfaces'
import {
  dateTimeAsUTCWithoutCompensation,
  ignoreTimezoneDate,
} from '../../helpers/date'

// bookingsStartDateTimestamps is used as a lookup table for a specific unix timestamp
// and facility as to have O(1) lookup when searching for a booking at a specific timeslot.

export function futureBookingsForUnits(
  unitIds: string[],
  facilityBookings: IBookingModel[]
): IBookingModel[] {
  return facilityBookings.filter(
    (booking) =>
      unitIds.find((unitId) => unitId === booking?.unitId) &&
      new Date(booking.endDate) > dateTimeAsUTCWithoutCompensation(new Date())
  )
}

export function futureBookingsForUnitsAndFacility(
  unitIds: string[],
  facilityBookings: IBookingModel[],
  facilityId: string
): IBookingModel[] {
  return futureBookingsForUnits(unitIds, facilityBookings).filter(
    (_booking) => _booking.facilityId === facilityId && !_booking.isAdmin
  )
}

export function bookingsForUserAndFacilityForSpecificDate(
  userBookings: IBookingModel[],
  facilityId: string,
  startDate: Date,
  endDate: Date
): IBookingModel[] {
  return userBookings.filter((booking) => {
    const bookingStartDate = ignoreTimezoneDate(new Date(booking.startDate))
    const bookingEndDate = ignoreTimezoneDate(new Date(booking.endDate))
    const isCorrectFacility = booking.facilityId === facilityId
    const isAfterStartDate = bookingStartDate >= startDate
    const isBeforeEndDate = bookingEndDate <= endDate

    return isCorrectFacility && isAfterStartDate && isBeforeEndDate
  })
}
